module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "net-worth-wrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm._translate('netWorth.title')))]), _vm._v(" "), _c('div', {
    staticClass: "report__client-info",
    domProps: {
      "innerHTML": _vm._s(_vm.showClientInfo())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-content"
  }, [_c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), (_vm.hasSpouse()) ? _c('Checkbox', {
    attrs: {
      "id": "spouseReport",
      "label": _vm._translate('netWorth.spouseReport'),
      "field": "details.spouseReport",
      "value": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setStoreTables()) ? _c('div', {
    staticClass: "net-worth__section net-worth__total"
  }, [_vm._v("\n        " + _vm._s(_vm._translate('netWorth.totalNetWorth')) + ": "), _c('span', {
    staticClass: "net-worth__value net-worth__total-value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getNetWorth()))
    }
  }), _vm._v(" "), (_vm.showNetWorthChart()) ? _c('Chart', {
    attrs: {
      "type": "bar",
      "stacked": "true",
      "data": _vm.chartNetWorth(),
      "id": "netWorth"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "net-worth__assets"
  }, [_c('h3', {
    staticClass: "net-worth__type-heading"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.assets')) + " "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getTypeTotal('assets')))
    }
  })]), _vm._v(" "), (_vm.showTotalAreaChart()) ? _c('Chart', {
    attrs: {
      "type": "pie",
      "data": _vm.chartTotalArea(),
      "id": "netWorthAssets"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), (_vm.getSectionTotal('liquid', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.liquidAssets')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('liquid', 'assets')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('savings.open.chequing', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.chequingAccounts')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.chequing', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.open.savings', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.savingsAccounts')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.savings', 'balance', false, true))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('semiliquid', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.semiliquidAssets')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('semiliquid', 'assets')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('savings.open.tfsa', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.tfsasTotal')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.tfsa', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.open.stocks', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.stocksTotal')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.stocks', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.open.mutualFunds', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.mutualFundsTotal')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.mutualFunds', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.open.other', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.otherSecuritiesTotal')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.open.other', 'balance', false, true))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('retirement', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.retirementSavings')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('retirement', 'assets')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('savings.registered.mutualFunds', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.mutualFundsTotal')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.registered.mutualFunds', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.registered.other', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.other')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.registered.other', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.registered.dpspEsopGrsp', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.dpspEsopGrsp')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.registered.dpspEsopGrsp', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.registered.rrif', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.rrifs')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.registered.rrif', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.lockedin.employerPension', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.employerPensionPlan')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.lockedin.employerPension', 'balance', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('savings.lockedin.lockedRrsp', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.lockedinRrsp')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('savings.lockedin.lockedRrsp', 'balance', false, true))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('realestate', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.realEstate')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('realestate', 'assets')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('assets.realEstate.home', 'value') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.homeValue')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('assets.realEstate.home', 'value', false, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('assets.realEstate.other', 'value') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.otherRealEstateValue')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('assets.realEstate.other', 'value', false, true))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('property', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.personalProperty')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('property', 'assets')))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('other', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.taxDeferredAssets')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('other', 'assets')))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('business', 'assets') > 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.businessInterests')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('business', 'assets')))
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "net-worth__liabilities"
  }, [_c('h3', {
    staticClass: "net-worth__type-heading"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.liabilities')) + " "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getTypeTotal('liabilities')))
    }
  })]), _vm._v(" "), (_vm.showTotalAreaChart('liabilities')) ? _c('Chart', {
    attrs: {
      "type": "pie",
      "data": _vm.chartTotalArea('liabilities'),
      "id": "netWorthLiabilities"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), (_vm.getSectionTotal('shortterm', 'liabilities') < 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.shortTermDebt')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('shortterm', 'liabilities')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('debt.shortTerm.creditCards', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.creditCards')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.shortTerm.creditCards', 'balance', true, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('debt.shortTerm.carLoans', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.carLoans')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.shortTerm.carLoans', 'balance', true, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('debt.shortTerm.lineOfCredit', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.lineOfCredit')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.shortTerm.lineOfCredit', 'balance', true, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('debt.shortTerm.other', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.otherLiabilities')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.shortTerm.other', 'balance', true, true))
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getSectionTotal('longterm', 'liabilities') < 0) ? _c('div', {
    staticClass: "net-worth__section"
  }, [_c('h4', {
    staticClass: "net-worth__section-heading"
  }, [_c('span', {
    staticClass: "net-worth__section-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.longTermDebt')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getDollarFormat(_vm.getSectionTotal('longterm', 'liabilities')))
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "net-worth__list"
  }, [(_vm.getRepeaterTotal('debt.longTerm.mortgageHome', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.mortgageOnHome')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.longTerm.mortgageHome', 'balance', true, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('debt.longTerm.mortgageOther', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.otherMortgages')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.longTerm.mortgageOther', 'balance', true, true))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getRepeaterTotal('debt.longTerm.investmentLoans', 'balance') > 0) ? _c('li', {
    staticClass: "net-worth__list-item"
  }, [_c('span', {
    staticClass: "net-worth__list-label"
  }, [_vm._v(_vm._s(_vm._translate('netWorth.investmentLoans')))]), _vm._v(" "), _c('span', {
    staticClass: "net-worth__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRepeaterTotal('debt.longTerm.investmentLoans', 'balance', true, true))
    }
  })]) : _vm._e()])]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61ef8563!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetWorth/NetWorth.vue
// module id = 324
// module chunks = 0